import { useTranslation } from "react-i18next";

const paymentGatewayOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "allinpay",
      title: t("options.gateway.allinpay"),
      value: "ALLINPAY",
      tag: ["settlement"],
    },
    {
      key: "alipay",
      title: t("options.gateway.alipay"),
      value: "ALIPAY",
      tag: ["settlement"],
    },
    {
      key: "amex_bbmsl",
      title: t("options.gateway.amex_bbmsl"),
      value: "AMEX_BBMSL",
      tag: ["settlement"],
    },
    {
      key: "fubon",
      title: t("options.gateway.fubon"),
      value: "FUBON",
      tag: ["settlement"],
    },
    {
      key: "hsbc",
      title: t("options.gateway.hsbc"),
      value: "HSBC",
      tag: ["settlement"],
    },
    {
      key: "nuvei",
      title: t("options.gateway.nuvei"),
      value: "NUVEI",
      tag: ["settlement"],
    },
    {
      key: "wechat_pay",
      title: t("options.gateway.wechat_pay"),
      value: "WECHAT_PAY",
      tag: ["settlement"],
    },
    {
      key: "worldpay",
      title: t("options.gateway.worldpay"),
      value: "WORLDPAY",
      tag: ["settlement"],
    },
    {
      key: "yedpay",
      title: t("options.gateway.yedpay"),
      value: "YEDPAY",
      tag: ["settlement"],
    },
  ];

  if (typeof list === "string") {
    if (list.toLowerCase() === "all") return options;
    return options.filter((option) =>
      option.tag?.some((tag) => tag === list.toLowerCase()),
    );
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default paymentGatewayOptions;
